export const IconBasketDelete40: {
  name: 'icon_basket_delete_40-48d60b001efb'
} = {
  name: 'icon_basket_delete_40-48d60b001efb'
}
